import { render, staticRenderFns } from "./EditLessonTypeDialog.vue?vue&type=template&id=95091e0c&scoped=true&"
import script from "@/views/LessonTypes/EditLessonTypeDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/LessonTypes/EditLessonTypeDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/LessonTypes/edit-lesson-type-dialog.scss?vue&type=style&index=0&id=95091e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95091e0c",
  null
  
)

export default component.exports